import Button from "@components/common/ui/Button";
import ProductImage from "@components/common/ui/ProductImage";
import { styled } from "@styles";
export const ProductContent = styled("div", {
  display: "flex",
  justifyContent: "space-between",
  gap: "$24px",
});

export const ProductDetails = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "$4px",
  marginBottom: "$12px",
  variants: {
    justifyCenter: {
      true: {
        justifyContent: "center",
      },
    },
  },
});

export const Image = styled(ProductImage, {
  borderRadius: "$md",
});

export const UpsellContent = styled("div", {
  display: "flex",
  alignItems: "center",
  gap: "$4px",
});
